export default function deleteExportedFileMock({ resolve }) {
	setTimeout(() => {
		resolve();
	}, 500);
}
